<template>
<div>
  <v-row class="no-gutters" justify="center" align="center" v-for="(noticia , n) in dataNoticias" :key="'noticia-'+n" >
    <v-col cols="12" sm="2" v-if="noticia.imagen">
      <div class="cont-img">
        <v-img 
        aspect-ratio="0.8"
        width="100%"
        :src="$store.state.rutaApi+noticia.imagen"
        ></v-img>
      </div>
    </v-col>
    <v-col cols="12" sm="12" class="pa-2 ">
      <div class="cont-noticia">
        <h2 class="mb-2">{{noticia.titulo}}</h2>
        <p class="ma-0" v-html="noticia.texto"></p>
        <v-divider class="mt-2"></v-divider>
        <div class="cont-referencia">
          <p style="d-flex" v-html="noticia.ref_general"></p>
        </div>
        <!-- <v-btn color="#0B542D" class="mt-2" small outlined link :href="noticia.enlace" target="_blank">
         <v-icon left>mdi-open-in-new</v-icon> Ampliar información
        </v-btn> -->
      </div>
    </v-col>
  </v-row>

</div>
</template>
<script>
export default {
  props:{
    dataNoticias:{}
  },
  data() {
    return {
    }
  },
}
</script>
<style lang="scss" scoped>
.cont-img{
  border: solid 1px #0B542D;
  border-radius: 10px;
  padding: 10px;
}
.cont-noticia{
  // box-shadow: 0 0 10px rgba($color: #000000, $alpha: .4);
  border: solid 1px #0B542D;
  border-radius: 10px;
  padding: 10px;
  h2{
    font-size: 1.1em;
  }
  p{
    font-size: 1em;
  }
}
.cont-referencia{
  padding-top: 5px;
  p{
    margin: 0px;
    font-size: 0.8em;
    line-height: 1em;
  }
}
</style>